// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ConfettiController from "./confetti_controller"
application.register("confetti", ConfettiController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LeadSwipeController from "./lead_swipe_controller"
application.register("lead-swipe", LeadSwipeController)

import FiltersController from "./filters_controller"
application.register("filters", FiltersController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import AddressController from "./address_controller"
application.register("address", AddressController)

import GalleryFiltersController from "./gallery_filters_controller"
application.register("gallery-filters", GalleryFiltersController)

import MapLoaderController from "./map_loader_controller"
application.register("map-loader", MapLoaderController)

import LocationFilterController from "./location_filter_controller"
application.register("location-filter", LocationFilterController)

import ProfileLocationController from "./profile_location_controller"
application.register("profile-location", ProfileLocationController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import MatchModalController from "./match_modal_controller"
application.register("match-modal", MatchModalController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import ChatMenuController from "./chat_menu_controller"
application.register("chat-menu", ChatMenuController)

import CropScreenController from "./crop_screen_controller"
application.register("crop-screen", CropScreenController)

import LandingController from "./landing_controller"
application.register("landing", LandingController)

import GenderFilterController from "./gender_filter_controller"
application.register("gender-filter", GenderFilterController)

import VisibilityToggleController from "./visibility_toggle_controller"
application.register("visibility-toggle", VisibilityToggleController)